export default __webpack_public_path__ + "static/signin-d8ce1d2529b24761de792aa06910c757.jpg";